export const SELECTION_MODE = {
  EXCLUDED: 'excluded',
  INCLUDED_FOR_CITY_ROUTE: 'includedForCityRoute'
} as const;

export type SelectionMode = (typeof SELECTION_MODE)[keyof typeof SELECTION_MODE];
